import { render, staticRenderFns } from "./ComplaintsLineChart.vue?vue&type=template&id=1202e2a0&"
import script from "./ComplaintsLineChart.vue?vue&type=script&lang=js&"
export * from "./ComplaintsLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports